import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"card-like",
	() => import("../ui/card-like-popup"),
)
